import { render, staticRenderFns } from "./Ideastorm.vue?vue&type=template&id=aafb965e&"
import script from "./Ideastorm.vue?vue&type=script&lang=js&"
export * from "./Ideastorm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports